import { FinanceRate } from '@kanda-libs/ks-frontend-services';

export const extractAprs = (rates: FinanceRate[]): string[] =>
  rates
    .filter((rate) => !rate.finance_types.includes('secondary'))
    .reduce((final: string[], rate: FinanceRate) => {
      const apr = String(rate?.apr || 0);
      const bnpl = rate.apr_type === 'BUYNOW_PAYLATER';
      const key = bnpl ? 'bnpl' : apr;
      if (final.includes(key)) return final;
      return [...final, key];
    }, []);
